import { stringify } from "querystringify"

import { PaymentSystemType } from "utils/interfaces"
import { GAZPROMPAY_MERCH_ID, GAZPROMPAY_PAGE_URL, STRIPE_PAGE_URL } from "utils/env-management"

export const getUrlForStripe = (
    returnUrl: string,
    order_hash: string,
    payment_system: PaymentSystemType | undefined,
    psy: { hashId: string; displayName: string },
    price_usd: string | number
) => {
    const stripePageURL = new URL(STRIPE_PAGE_URL)
    const newRedirectUrl = new URL(returnUrl)
    newRedirectUrl.host = stripePageURL.host

    const queryParams = stringify({
        order_hash,
        payment_system,
        return_url: newRedirectUrl.toString(),
        psy: JSON.stringify({ hash_id: psy.hashId, display_name: psy.displayName }),
        ...(price_usd && { price_usd: price_usd }),
    })
    return `${STRIPE_PAGE_URL}/stripe/?${queryParams}`
}

export const getUrlForGazprompay = (returnUrl: string, order_hash: string) => {
    const queryParams = stringify({
        lang_code: "RU",
        merch_id: GAZPROMPAY_MERCH_ID,
        back_url_s: returnUrl,
        back_url_f: window.location.href,
        "o.order_id": order_hash,
    })
    return `${GAZPROMPAY_PAGE_URL}?${queryParams}`
}
